export default __webpack_public_path__ + "static/media/template.aaf79db2.csv";